import React, { Component } from 'react';
import FullBanner from './FullBanner';
import TextOnlyBanner from './TextOnlyBanner';
import ThumbnailOnlyBanner from './ThumbnailOnlyBanner';

const Banner = function(props) {
    let hasLargeImage = props.imageLarge && props.imageLarge.length > 1 && props.imageLarge !== 'img.png' && props.imageLarge !== 'https://s3.us-east-2.amazonaws.com/arrowpos-assets/recurve_filler_images/filler_2_item.png'; //Check for all cases we consider 'no image'
    let hasSmallImage = props.imageSmall && props.imageSmall.length > 1 && props.imageSmall !== 'img.png' && props.imageSmall !== 'https://s3.us-east-2.amazonaws.com/arrowpos-assets/recurve_filler_images/filler_2_item.png'; //Check for all cases we consider 'no image'
    let isTextOnly = (!hasLargeImage && !hasSmallImage); //If both are unset, this is text only
    let isThumbnailOnly = (!hasLargeImage && hasSmallImage); // If we only have a small image, this is thumbnail only
    if(isTextOnly) return <TextOnlyBanner>{props}</TextOnlyBanner>
    if(isThumbnailOnly) return <ThumbnailOnlyBanner>{props}</ThumbnailOnlyBanner>
    return <FullBanner>{props}</FullBanner> //Defaults to full banner
};

export default Banner;